<template>
  <div>
    <va-card>
      <div class="row justify--space-between" style="margin: 0 !important;">
        <h5 v-if="title">{{title}} </h5>
        <div class="text-center" v-if="isLoading">
          <LoadingAnimation/>
        </div>
        <span v-else class="is-bold" :class="{'recent-update': hasBeenUpdatedRecently}">{{$t('dashboard_new_evollu.titles.last_update')}}: {{lastUpdate || "N/A"}} &nbsp;
        <i class="clickable" :class="{'fa fa-chevron-down' : isCollapsed, 'fa fa-chevron-up': !isCollapsed}"
           style="color: #1ED78D"
           @click.prevent="isCollapsed = !isCollapsed"
        >
        </i>
      </span>

      </div>
      <div v-if="!isCollapsed" class="col-12" style="margin: 0 !important;">
        <slot></slot>
      </div>
    </va-card>
  </div>
</template>

<script>
import moment from "moment";
import LoadingAnimation from "@/components/users/components/Helpers/LoadingAnimation.vue";

export default {
  components: {LoadingAnimation},
  props: {
    lastUpdate: {
      type: String,
      required: false,
      default: null
    },
    title: {
      type: String,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      isCollapsed: true,
    }
  },
  computed: {
    hasBeenUpdatedRecently: function () {
      if(this.lastUpdate !== null) {
        return moment().diff(moment(this.lastUpdate), 'hours' )  < 12
      }
      return false
    }
  }
}
</script>

<style scoped>
.recent-update {
  color: #73d30a;
}

</style>
